const FONT_AWESOME_ICONS_DATA: {
    name: string;
    keywords: string[];
}[] = [
    {
        name: 'location-dot-solid',
        keywords: ['location', 'dot', 'point']
    },
    {
        name: 'location-pin-solid',
        keywords: ['location', 'pin', 'point']
    },
    {
        name: 'map-pin-solid',
        keywords: ['map', 'pin', 'point']
    },
    {
        name: 'basket-shopping-solid',
        keywords: ['shopping', 'basket', 'cart']
    },
    {
        name: 'bed-solid',
        keywords: ['bed', 'sleep', 'rest']
    },
    {
        name: 'beer-mug-solid',
        keywords: ['beer', 'mug', 'drink']
    },
    {
        name: 'bell-on-solid',
        keywords: ['bell', 'alarm', 'notification']
    },
    {
        name: 'bicycle-solid',
        keywords: ['bicycle', 'bike', 'transportation']
    },
    {
        name: 'bolt-solid',
        keywords: ['bolt', 'lightning', 'electricity']
    },
    {
        name: 'bomb-solid',
        keywords: ['bomb', 'explosion', 'danger']
    },
    {
        name: 'building-solid',
        keywords: ['building', 'house', 'home']
    },
    {
        name: 'bullhorn-solid',
        keywords: ['bullhorn', 'megaphone', 'announcement']
    },
    {
        name: 'burger-cheese-solid',
        keywords: ['burger', 'cheese', 'food']
    },
    {
        name: 'burger-soda-solid',
        keywords: ['burger', 'soda', 'food']
    },
    {
        name: 'bus-solid',
        keywords: ['bus', 'transportation']
    },
    {
        name: 'camera-retro-solid',
        keywords: ['camera', 'retro', 'photo']
    },
    {
        name: 'camera-solid',
        keywords: ['camera', 'photo']
    },
    {
        name: 'campground-solid',
        keywords: ['campground', 'tent', 'camping']
    },
    {
        name: 'car-side-solid',
        keywords: ['car', 'side', 'transportation']
    },
    {
        name: 'car-solid',
        keywords: ['car', 'transportation']
    },
    {
        name: 'cart-shopping-solid',
        keywords: ['cart', 'shopping', 'basket']
    },
    {
        name: 'champagne-glass-solid',
        keywords: ['champagne', 'glass', 'drink']
    },
    {
        name: 'check-solid',
        keywords: ['check', 'tick', 'success']
    },
    {
        name: 'circle-exclamation-solid',
        keywords: ['circle', 'exclamation', 'warning']
    },
    {
        name: 'circle-info-solid',
        keywords: ['circle', 'info', 'information']
    },
    {
        name: 'circle-xmark-solid',
        keywords: ['circle', 'xmark', 'close', 'cancel']
    },
    {
        name: 'cloud-solid',
        keywords: ['cloud', 'weather']
    },
    {
        name: 'comment-solid',
        keywords: ['comment', 'chat', 'message']
    },
    {
        name: 'crosshairs-solid',
        keywords: ['crosshairs', 'target', 'aim']
    },
    {
        name: 'do-not-enter-solid',
        keywords: ['do', 'not', 'enter', 'forbidden']
    },
    {
        name: 'dog-solid',
        keywords: ['dog', 'pet', 'animal']
    },
    {
        name: 'droplet-solid',
        keywords: ['droplet', 'water', 'drop']
    },
    {
        name: 'envelope-solid',
        keywords: ['envelope', 'mail', 'email']
    },
    {
        name: 'eyes-solid',
        keywords: ['eyes', 'eye', 'look']
    },
    {
        name: 'face-flushed-solid',
        keywords: ['face', 'flushed', 'blush', 'emoji']
    },
    {
        name: 'face-frown-slight-solid',
        keywords: ['face', 'frown', 'slight', 'emoji']
    },
    {
        name: 'face-grin-hearts-solid',
        keywords: ['face', 'grin', 'hearts', 'emoji']
    },
    {
        name: 'face-laugh-solid',
        keywords: ['face', 'laugh', 'emoji']
    },
    {
        name: 'face-pouting-solid',
        keywords: ['face', 'pouting', 'emoji']
    },
    {
        name: 'face-sad-tear-solid',
        keywords: ['face', 'sad', 'tear', 'emoji']
    },
    {
        name: 'face-smile-beam-solid',
        keywords: ['face', 'smile', 'beam', 'emoji']
    },
    {
        name: 'face-smile-solid',
        keywords: ['face', 'smile', 'emoji']
    },
    {
        name: 'fire-solid',
        keywords: ['fire', 'flame', 'hot']
    },
    {
        name: 'flag-solid',
        keywords: ['flag', 'country', 'nation']
    },
    {
        name: 'flag-swallowtail-solid',
        keywords: ['flag', 'swallowtail', 'country', 'nation']
    },
    {
        name: 'fork-knife-solid',
        keywords: ['fork', 'knife', 'food']
    },
    {
        name: 'fort-solid',
        keywords: ['fort', 'castle', 'building']
    },
    {
        name: 'french-fries-solid',
        keywords: ['french', 'fries', 'food']
    },
    {
        name: 'gas-pump-solid',
        keywords: ['gas', 'pump', 'fuel']
    },
    {
        name: 'gem-solid',
        keywords: ['gem', 'diamond', 'jewel']
    },
    {
        name: 'gift-solid',
        keywords: ['gift', 'present', 'box']
    },
    {
        name: 'graduation-cap-solid',
        keywords: ['graduation', 'cap', 'education']
    },
    {
        name: 'heart-solid',
        keywords: ['heart', 'love']
    },
    {
        name: 'house-solid',
        keywords: ['house', 'home']
    },
    {
        name: 'image-solid',
        keywords: ['image', 'picture', 'photo']
    },
    {
        name: 'key-solid',
        keywords: ['key', 'lock']
    },
    {
        name: 'landmark-solid',
        keywords: ['landmark', 'building']
    },
    {
        name: 'lightbulb-solid',
        keywords: ['lightbulb', 'idea', 'light']
    },
    {
        name: 'location-arrow-solid',
        keywords: ['location', 'arrow', 'direction']
    },

    {
        name: 'magnifying-glass-solid',
        keywords: ['magnifying', 'glass', 'search']
    },
    {
        name: 'medal-solid',
        keywords: ['medal', 'award', 'trophy']
    },
    {
        name: 'mountain-solid',
        keywords: ['mountain', 'nature']
    },
    {
        name: 'music-solid',
        keywords: ['music', 'note', 'sound']
    },
    {
        name: 'person-dress-solid',
        keywords: ['person', 'dress', 'clothing', 'toilet']
    },
    {
        name: 'person-solid',
        keywords: ['person', 'human', 'toilet']
    },
    {
        name: 'phone-solid',
        keywords: ['phone', 'call']
    },
    {
        name: 'pizza-slice-solid',
        keywords: ['pizza', 'slice', 'food']
    },
    {
        name: 'plane-up-solid',
        keywords: ['plane', 'up', 'airplane', 'fly']
    },
    {
        name: 'poo-solid',
        keywords: ['poo', 'poop', 'shit', 'emoji']
    },
    {
        name: 'popsicle-solid',
        keywords: ['popsicle', 'ice', 'cream']
    },
    {
        name: 'restroom-solid',
        keywords: ['bathroom', 'toilet', 'restroom']
    },
    {
        name: 'wheelchair-solid',
        keywords: ['bathroom', 'toilet', 'wheelchair']
    },
    {
        name: 'rocket-launch-solid',
        keywords: ['space', 'launch', 'rocket']
    },
    {
        name: 'rv-solid',
        keywords: ['rv', 'camper']
    },
    {
        name: 'sailboat-solid',
        keywords: ['sailboat', 'boat', 'marine']
    },
    {
        name: 'shield-solid',
        keywords: ['shield', 'armor', 'protection']
    },
    {
        name: 'ship-solid',
        keywords: ['']
    },
    {
        name: 'ship-solid',
        keywords: ['ship', 'sea', 'maritime']
    },
    {
        name: 'skull-crossbones-solid',
        keywords: ['skull', 'danger', 'poison']
    },
    {
        name: 'spa-solid',
        keywords: ['spa', 'relax', 'massage', 'wellness']
    },
    {
        name: 'star-solid',
        keywords: ['star', 'favorite']
    },
    {
        name: 'suitcase-rolling-solid',
        keywords: ['suitcase', 'travel', 'luggage']
    },
    {
        name: 'sun-solid',
        keywords: ['sun', 'sunshine', 'weather']
    },
    {
        name: 'tag-solid',
        keywords: ['tag', 'label']
    },
    {
        name: 'taxi-solid',
        keywords: ['taxi', 'car', 'transportation']
    },
    {
        name: 'tent-solid',
        keywords: ['tent', 'camping']
    },
    {
        name: 'thumbs-down-solid',
        keywords: ['thumbs', 'down', 'dislike']
    },
    {
        name: 'thumbs-up-solid',
        keywords: ['thumbs', 'up', 'like']
    },
    {
        name: 'thumbtack-solid',
        keywords: ['thumbtack', 'pin', 'point']
    },
    {
        name: 'toolbox-solid',
        keywords: ['toolbox', 'tools']
    },
    {
        name: 'tractor-solid',
        keywords: ['tractor', 'farm']
    },
    {
        name: 'train-subway-solid',
        keywords: ['train', 'subway', 'metro']
    },
    {
        name: 'trash-solid',
        keywords: ['trash', 'delete']
    },
    {
        name: 'tree-solid',
        keywords: ['tree', 'nature']
    },
    {
        name: 'triangle-exclamation-solid',
        keywords: ['triangle', 'exclamation', 'warning']
    },
    {
        name: 'trophy-solid',
        keywords: ['trophy', 'award', 'medal']
    },
    {
        name: 'truck-fast-solid',
        keywords: ['truck', 'fast', 'transportation']
    },
    {
        name: 'user-solid',
        keywords: ['user', 'person', 'human']
    },
    {
        name: 'train-tram-solid',
        keywords: ['tram', 'train', 'transportation']
    },
    {
        name: 'arrow-right-solid',
        keywords: ['arrow', 'right', 'direction']
    },
    {
        name: 'stairs-up',
        keywords: ['stairs', 'up', 'down', 'direction']
    },
    {
        name: 'stairs-down',
        keywords: ['stairs', 'up', 'down', 'direction']
    },
    {
        name: 'mug-hot-solid',
        keywords: ['coffee', 'mug', 'hot', 'drink']
    },
    {
        name: 'presentation-screen-solid',
        keywords: ['presentation', 'screen', 'monitor']
    },
    {
        name: 'square-parking-solid',
        keywords: ['square', 'parking', 'car']
    },
    {
        name: 'person-walking-solid',
        keywords: ['person', 'walking', 'human']
    },
    {
        name: 'person-skiing-solid',
        keywords: ['person', 'skiing', 'human']
    },
    {
        name: 'person-biking-solid',
        keywords: ['person', 'biking', 'human']
    },
    {
        name: 'windsock-solid',
        keywords: ['windsock', 'wind', 'sock']
    },
    {
        name: 'flag-checkered-solid',
        keywords: ['flag', 'checkered', 'finish', 'line']
    },
    {
        name: 'hotdog-solid',
        keywords: ['hotdog', 'food']
    },
    {
        name: 'anchor-solid',
        keywords: ['anchor', 'boat', 'sea', 'marine']
    },
    {
        name: 'ice-skate-solid',
        keywords: ['ice', 'skate', 'skating']
    },
    {
        name: 'waffle-solid',
        keywords: ['waffle', 'food']
    },
    {
        name: 'child-reaching-solid',
        keywords: ['child', 'reaching', 'hand']
    },
    {
        name: 'water-solid',
        keywords: ['water', 'drink']
    },
    {
        name: 'truck-solid',
        keywords: ['truck', 'transportation']
    },
    {
        name: 'credit-card-solid',
        keywords: ['credit', 'card', 'payment']
    },
    {
        name: 'phone-office-solid',
        keywords: ['phone', 'office', 'call']
    },
    {
        name: 'game-board-simple-solid',
        keywords: ['game', 'board', 'simple']
    },
    {
        name: 'hill-avalanche-solid',
        keywords: ['hill', 'avalanche', 'snow']
    },
    {
        name: 'heat-solid',
        keywords: ['heat', 'temperature', 'hot']
    },
    {
        name: 'ball-pile-solid',
        keywords: ['ball', 'pile', 'toy']
    },
    {
        name: 'party-bell-solid',
        keywords: ['party', 'bell', 'celebration']
    },
    {
        name: 'party-horn-solid',
        keywords: ['party', 'horn', 'celebration']
    },
    {
        name: 'store-solid',
        keywords: ['store', 'shop']
    },
    {
        name: 'plus-solid',
        keywords: ['plus', 'add', 'create']
    },
    {
        name: 'person-sledding-solid',
        keywords: ['person', 'sledding', 'human']
    },
    {
        name: 'recycle-solid',
        keywords: ['recycle', 'environment', 'green']
    },
    {
        name: 'compass-solid',
        keywords: ['compass', 'direction', 'navigation']
    },
    {
        name: 'leaf-solid',
        keywords: ['leaf', 'nature', 'green']
    },
    {
        name: 'kite-sharp-solid',
        keywords: ['kite', 'sharp', 'fly']
    },
    {
        name: 'reel-solid',
        keywords: ['reel', 'film', 'movie']
    },
    {
        name: 'question-solid',
        keywords: ['question', 'mark', 'help']
    },
    {
        name: 'elevator-solid',
        keywords: ['elevator', 'lift']
    },
    {
        name: 'circle-arrow-down-solid',
        keywords: ['circle', 'arrow', 'down', 'direction']
    },
    {
        name: 'circle-arrow-up-solid',
        keywords: ['circle', 'arrow', 'up', 'direction']
    },
    {
        name: 'circle-arrow-left-solid',
        keywords: ['circle', 'arrow', 'left', 'direction']
    },
    {
        name: 'circle-arrow-right-solid',
        keywords: ['circle', 'arrow', 'right', 'direction']
    },
    {
        name: 'down-solid',
        keywords: ['down', 'arrow', 'direction']
    },
    {
        name: 'left-solid',
        keywords: ['left', 'arrow', 'direction']
    },
    {
        name: 'right-solid',
        keywords: ['right', 'arrow', 'direction']
    },
    {
        name: 'up-solid',
        keywords: ['up', 'arrow', 'direction']
    },
    {
        name: 'umbrella-solid',
        keywords: ['umbrella', 'rain', 'weather']
    },
    {
        name: 'panorama-solid',
        keywords: ['panorama', 'view', 'landscape']
    },
    {
        name: 'clothes-hanger-solid',
        keywords: ['clothes', 'hanger', 'wardrobe']
    },
    {
        name: 'radar-solid',
        keywords: ['radar', 'dish', 'antenna']
    },
    {
        name: 'handshake-solid',
        keywords: ['handshake', 'deal', 'agreement', 'meeting']
    }
];

export function getFontAwesomeIcons(): {
    key: string;
    imageUrl: string;
    keywords: string[];
}[] {
    return FONT_AWESOME_ICONS_DATA.map((source) => {
        return {
            key: source.name,
            imageUrl: `https://dvtqxks0zalev.cloudfront.net/font-icons/Svgs/${source.name}.svg`,
            keywords: source.keywords
        };
    });
}
